import classNames from "classnames";
import { FC } from "react";

import { Typography } from "@/shared/ui";
import BankCardsIcon from "@/svgs/banks_cards.svg";

import styles from "./footer.module.scss";
import { FooterProps } from "./footer.types";

const Footer: FC<FooterProps> = ({
  theme = "black",
  fixedAtBottom = false,
  transparent = false,
  centered = false,
  fullWidth = false,
}) => {
  return (
    <footer
      className={classNames(
        styles.footerContainer,
        fixedAtBottom && styles.fixedAtBottom,
        transparent && styles.transparent,
        centered && styles.centered,
        fullWidth && styles.fullWidth,
        styles[theme]
      )}
    >
      <a href="/terms-and-privacy" target="_blank">
        <Typography variant="subheadline" color={theme === "black" ? "white" : "black"}>
          Privacy Policy
        </Typography>
      </a>

      <a href="/terms-of-use" target="_blank">
        <Typography variant="subheadline" color={theme === "black" ? "white" : "black"}>
          Terms Of Use
        </Typography>
      </a>
      <BankCardsIcon />
    </footer>
  );
};

export { Footer };
